export const ROLES = [
  {
    id: "civilian",
    label: "Мирний житель",
    side: "town",
    abilities: [],
    nightAction: null,
    icon: "👤",
    description:
      "Чесний мешканець міста. Уночі спить, а вдень обговорює події, шукає мафію та голосує за вигнання підозрюваних.",
  },
  {
    id: "mafia",
    label: "Мафія",
    side: "mafia",
    abilities: ["kill"],
    nightAction: "kill",
    icon: "🕶️",
    description:
      "Член кримінального клану. Щоночі разом зі спільниками прокидається та обирає жертву для ліквідації.",
  },
  {
    id: "don",
    label: "Дон мафії",
    side: "mafia",
    abilities: ["kill", "check"],
    nightAction: "check",
    icon: "🎩",
    description:
      "Глава мафії. Має вирішальний голос під час нічного замаху, а також окремо щоночі шукає комісара.",
  },
  {
    id: "sheriff",
    label: "Комісар",
    side: "town",
    abilities: ["check", "kill"],
    nightAction: "check",
    icon: "🕵️‍♂️",
    description:
      "Головний захисник міста. Щоночі перевіряє одного гравця на причетність до мафії (або може зробити постріл на ураження).",
  },
  {
    id: "sergeant",
    label: "Сержант",
    side: "town",
    abilities: ["check", "kill"],
    nightAction: "check",
    icon: "👮",
    description:
      "Помічник комісара. Знає перевірки комісара, а в разі його загибелі перебирає на себе обов'язки шерифа.",
  },
  {
    id: "doctor",
    label: "Лікар",
    side: "town",
    abilities: ["heal"],
    nightAction: "heal",
    icon: "💉",
    description:
      "Рятівник міста. Щоночі обирає одного гравця і лікує його від смертельного замаху.",
  },
  {
    id: "maniac",
    label: "Маніяк",
    side: "solo",
    abilities: ["kill"],
    nightAction: "kill",
    icon: "🔪",
    description:
      "Одинокий хижак. Грає сам за себе. Щоночі вбиває обрану жертву та прагне залишитися єдиним вижилим за столом.",
  },
  {
    id: "prostitute",
    label: "Путана",
    side: "town",
    abilities: ["block"],
    nightAction: "block",
    icon: "💋",
    description:
      "Красуня міста. Щоночі відвідує одного гравця і блокує будь-яку його нічну дію цієї ночі.",
  },
  {
    id: "tramp",
    label: "Волоцюга",
    side: "town",
    abilities: ["witness"],
    nightAction: "witness",
    icon: "🎒",
    description:
      "Нічний блукач. Щоночі обирає дім іншого гравця для ночівлі. Якщо на господаря скоєно замах — присутність волоцюги рятує його, або волоцюга стає свідком нападу.",
  },
  {
    id: "journalist",
    label: "Журналіст",
    side: "town",
    abilities: ["compare"],
    nightAction: "compare",
    icon: "📰",
    description:
      "Шукач сенсацій. Щоночі обирає двох гравців і дізнається у ведучого, чи належать вони до однієї команди (Мирні / Мафія).",
  },
  {
    id: "bodyguard",
    label: "Тілоохоронець",
    side: "town",
    abilities: ["guard"],
    nightAction: "guard",
    icon: "🛡️",
    description:
      "Особиста охорона. Щоночі охороняє одного гравця від смертельного замаху (не може охороняти самого себе).",
  },
  {
    id: "lawyer",
    label: "Адвокат",
    side: "mafia",
    abilities: ["check"],
    nightAction: "check",
    icon: "⚖️",
    description:
      "Юрист мафії. Щоночі перевіряє жителя міста і дізнається його точну роль, допомагаючи мафії вирахувати комісара чи лікаря.",
  },
  {
    id: "kamikaze",
    label: "Камікадзе",
    side: "town",
    abilities: ["retaliate"],
    nightAction: null,
    icon: "💥",
    description:
      "Відчайдушний месник. Якщо камікадзе гине від нічного замаху чи денного голосування, він забирає свого вбивцю або підозрюваного із собою в могилу.",
  },
  {
    id: "poisoner",
    label: "Отруйник",
    side: "mafia",
    abilities: ["poison"],
    nightAction: "poison",
    icon: "🧪",
    description:
      "Підступний алхімік мафії. Щоночі підсипає отруту гравцю. Отруєний проживає наступний день і гине наступної ночі, якщо лікар не вилікує його.",
  },
  {
    id: "priest",
    label: "Священник",
    side: "town",
    abilities: ["confess"],
    nightAction: "confess",
    icon: "⛪",
    description:
      "Духівник міста. Щоночі приходить до гравця на сповідь і дізнається, чи його душа «грішна» (мафія, маніяк), чи «чиста» (мирний житель).",
  },
  {
    id: "spy",
    label: "Шпигун",
    side: "town",
    abilities: ["track"],
    nightAction: "track",
    icon: "👁️",
    description:
      "Таємний агент. Щоночі слідкує за підозрюваним і дізнається, чи виходив той цієї ночі для виконання активної дії.",
  },
  {
    id: "lucky",
    label: "Щасливчик",
    side: "town",
    abilities: [],
    nightAction: null,
    icon: "🍀",
    description:
      "Неймовірно везучий житель. Має дивовижну вдачу: витримує та виживає після першого замаху на своє життя (помирає лише від повторного нападу).",
  },
  {
    id: "godfather",
    label: "Хрещений батько",
    side: "mafia",
    abilities: ["kill"],
    nightAction: "kill",
    icon: "👑",
    description:
      "Тіньовий авторитет мафії. Бере участь у вбивствах клану. При будь-якій перевірці комісаром чи священником показується як чесний мирний житель.",
  },
];

// Порядок ходів уночі.
export const NIGHT_STEPS = [
  {
    id: "prostitute-block",
    roleIds: ["prostitute"],
    actionTypes: ["block"],
    label: "Путана блокує дію",
  },
  {
    id: "bodyguard-guard",
    roleIds: ["bodyguard"],
    actionTypes: ["guard"],
    label: "Тілоохоронець обирає захист",
  },
  {
    id: "mafia-kill",
    roleIds: ["don", "godfather", "mafia"],
    actionTypes: ["kill"],
    label: "Вбивство мафії",
    hint: "Записуйте як вбивство від дона / хрещеного батька — фінальне слово за ним.",
  },
  {
    id: "poisoner-poison",
    roleIds: ["poisoner"],
    actionTypes: ["poison"],
    label: "Отруйник мафії підсипає отруту",
  },
  {
    id: "lawyer-check",
    roleIds: ["lawyer"],
    actionTypes: ["check"],
    label: "Адвокат мафії перевіряє роль",
  },
  {
    id: "don-check",
    roleIds: ["don"],
    actionTypes: ["check"],
    label: "Дон перевіряє комісара",
  },
  {
    id: "sheriff-turn",
    roleIds: ["sheriff"],
    actionTypes: ["check", "kill"],
    label: "Хід комісара",
  },
  {
    id: "sergeant-turn",
    roleIds: ["sergeant"],
    actionTypes: ["check", "kill"],
    label: "Хід сержанта",
  },
  {
    id: "priest-confess",
    roleIds: ["priest"],
    actionTypes: ["confess"],
    label: "Священник сповідає гравця",
  },
  {
    id: "journalist-compare",
    roleIds: ["journalist"],
    actionTypes: ["compare"],
    label: "Журналіст порівнює двох гравців",
  },
  {
    id: "spy-track",
    roleIds: ["spy"],
    actionTypes: ["track"],
    label: "Шпигун стежить за гравцем",
  },
  {
    id: "doctor-heal",
    roleIds: ["doctor"],
    actionTypes: ["heal"],
    label: "Лікар лікує від замаху",
  },
  {
    id: "maniac-kill",
    roleIds: ["maniac"],
    actionTypes: ["kill"],
    label: "Хід маніяка",
  },
  {
    id: "tramp-witness",
    roleIds: ["tramp"],
    actionTypes: ["witness"],
    label: "Волоцюга йде на нічліг",
  },
];

// Правила дій зібрані в одному місці, щоб не прив'язувати ActionForm
// до конкретних назв ролей. Новій ролі достатньо видати abilities вище.
export const ACTION_RULES = {
  kill: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "kill",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
  },
  heal: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "heal",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: true,
    uniqueActorPerRound: true,
  },
  check: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "check",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorTarget: true,
  },
  block: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "block",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorPerRound: true,
  },
  guard: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "guard",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorPerRound: true,
  },
  witness: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "witness",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorPerRound: true,
  },
  compare: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "compare",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorPerRound: true,
  },
  poison: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "poison",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorPerRound: true,
  },
  confess: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "confess",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorTarget: true,
  },
  track: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "track",
    actorMustBeAlive: true,
    targetMustBeAlive: true,
    allowSelfTarget: false,
    uniqueActorPerRound: true,
  },
  retaliate: {
    needsActor: true,
    needsTarget: true,
    allowedAbility: "retaliate",
    actorMustBeAlive: false,
    targetMustBeAlive: true,
    allowSelfTarget: false,
  },
  vote_out: {
    needsActor: false,
    needsTarget: true,
    targetMustBeAlive: true,
  },
};

export const ACTION_TYPES = [
  { id: "kill", label: "Вбивство (ніч)" },
  { id: "check", label: "Перевірка" },
  { id: "compare", label: "Порівняння (журналіст)" },
  { id: "guard", label: "Охорона (тілоохоронець)" },
  { id: "witness", label: "Нічліг (волоцюга)" },
  { id: "block", label: "Блокування (путана)" },
  { id: "poison", label: "Отруєння (отруйник)" },
  { id: "confess", label: "Сповідь (священник)" },
  { id: "track", label: "Стеження (шпигун)" },
  { id: "retaliate", label: "Підрив (камікадзе)" },
  { id: "heal", label: "Лікування" },
  { id: "vote_out", label: "Вигнання голосуванням (день)" },
];

export function getRole(roleId) {
  return ROLES.find((r) => r.id === roleId) || null;
}

export function roleLabel(roleId) {
  return getRole(roleId)?.label || roleId;
}

export function roleSide(roleId) {
  return getRole(roleId)?.side || "town";
}

export function roleDescription(roleId) {
  return getRole(roleId)?.description || "";
}

export function roleIcon(roleId) {
  return getRole(roleId)?.icon || "🎭";
}

// CSS-клас для кольору ролі — використовується в картках гравців, чіпах
// вибору гравця та журналі дій, щоб колірне кодування було однаковим скрізь.
export function roleClass(roleId) {
  return `role-color-${roleId}`;
}

export const SIDE_LABELS = {
  town: "Мирні",
  mafia: "Мафія",
  solo: "Соло",
  draw: "Нічия",
};

export function canRolePerform(roleId, actionType) {
  const role = getRole(roleId);
  const rule = ACTION_RULES[actionType];

  if (!role || !rule?.allowedAbility) return false;
  return role.abilities?.includes(rule.allowedAbility) ?? false;
}

export function actionLabel(typeId) {
  return ACTION_TYPES.find((a) => a.id === typeId)?.label || typeId;
}

// Живі гравці, які можуть виконати цю дію (для тапабельних чіпів у формі дії
// та для підсвітки карток на дошці гравців у режимі вибору).
export function eligibleActors(players, typeId) {
  const rule = ACTION_RULES[typeId] || {};
  if (!rule.needsActor) return [];
  // Камікадзе може помститися навіть після загибелі
  if (typeId === "retaliate") {
    return players.filter((p) => canRolePerform(p.role, typeId));
  }
  return players.filter((p) => p.alive && canRolePerform(p.role, typeId));
}

// Живі гравці, яких можна обрати ціллю цієї дії (з урахуванням заборони
// вибирати самого себе, де це не дозволено).
export function eligibleTargets(players, typeId, actorId) {
  const rule = ACTION_RULES[typeId] || {};
  if (!rule.needsTarget) return [];
  let list = players.filter((p) => p.alive);
  if (actorId && !rule.allowSelfTarget) {
    list = list.filter((p) => String(p.id) !== String(actorId));
  }
  return list;
}

// Черга нічних дій для поточного раунду: для кожного кроку NIGHT_STEPS, чиї
// ролі присутні серед живих гравців, перевіряємо, чи вже записана відповідна
// дія цього раунду від гравця однієї з цих ролей. Перший невиконаний пункт —
// той, кого ведучий має викликати наступним.
export function getNightQueue(players, actions, round) {
  return NIGHT_STEPS.map((step) => {
    // Усі гравці цієї ролі в грі, живі чи мертві.
    const allRolePlayers = players.filter((p) => step.roleIds.includes(p.role));
    if (allRolePlayers.length === 0) return null;

    const aliveRolePlayers = allRolePlayers.filter((p) => p.alive);
    const deadRole = aliveRolePlayers.length === 0;

    const rolePlayers = deadRole ? allRolePlayers : aliveRolePlayers;

    const primaryRoleId =
      step.roleIds.find((r) => rolePlayers.some((p) => p.role === r)) ||
      rolePlayers[0].role;

    const roleLabelText = [...new Set(rolePlayers.map((p) => p.role))]
      .map((r) => roleLabel(r))
      .join(" / ");

    const done =
      deadRole ||
      actions.some(
        (a) =>
          step.actionTypes.includes(a.type) &&
          Number(a.round) === Number(round) &&
          rolePlayers.some((p) => String(p.id) === String(a.actorId))
      );

    const suggestedActor = deadRole
      ? null
      : rolePlayers.find((p) => p.role === primaryRoleId) || rolePlayers[0];

    return {
      stepId: step.id,
      stepLabel: step.label,
      roleId: primaryRoleId,
      roleLabel: roleLabelText,
      actionTypeId: step.actionTypes[0],
      actionTypeIds: step.actionTypes,
      actionText:
        step.actionTypes.length > 1
          ? step.actionTypes.map((t) => actionLabel(t)).join(" або ")
          : actionLabel(step.actionTypes[0]),
      hint: step.hint || null,
      done,
      deadRole,
      players: rolePlayers,
      suggestedActorId: suggestedActor ? suggestedActor.id : null,
    };
  }).filter(Boolean);
}

// Поточний (перший невиконаний) крок нічної черги — використовується, щоб
// автоматично підставляти потрібний тип дії у форму запису, поки триває ніч.
export function getCurrentNightStep(players, actions, round) {
  const queue = getNightQueue(players, actions, round);
  return queue.find((q) => !q.done) || null;
}
